import React, { Component } from 'react'
import { displayOddsType, getDisplayCurrency, currencyToText, SPORTS } from 'utils/converters'
import moment from 'moment'
import { bookmakers } from 'config'
import ReactTooltip from 'react-tooltip'
import { connect } from 'react-redux'
import { addUserbet, editUserbet } from 'actions/userbets'

const mapOddsTypeObjects = {
  Home: 'H',
  Away: 'A'
}

class SelectedEdge extends Component {
  constructor(props) {
    super(props)
    this.onChangeCurrency = this.onChangeCurrency.bind(this)
    this.onChangeWager = this.onChangeWager.bind(this)
    this.addUserbet = this.addUserbet.bind(this)
    this.state = {
      wager: 100,
      currency: this.props.user.currency,
      userbet: null
    }
  }

  onChangeCurrency(e) {
    this.setState({
      currency: e.target.value
    })
  }

  onChangeWager(e) {
    this.setState({
      wager: +e.target.value
    })
  }

  hideEdge() {
    window.analytics.track('Hide edge')
    this.props.onHideEdge(this.props.edge.offer)
  }

  addUserbet(e) {
    e.preventDefault()
    const { dispatch, edge } = this.props
    if (this.state.userbet) {
      window.analytics.track('Edited a bet from edgebet')
      dispatch(editUserbet(this.state.userbet.id, {
        wager: this.state.wager,
        currency: this.state.currency,
        edge: edge.edge
      }))
    } else {
      dispatch(addUserbet({
        baseline: edge.baseline,
        wager: +this.state.wager,
        currency: this.state.currency,
        sportId: edge.sportId,
        match: {
          _id: edge.matchId,
          startTime: edge.startTime,
          homeTeam: edge.homeTeam,
          awayTeam: edge.awayTeam,
          competition: edge.competition,
          country: edge.country
        },
        bookmaker: {
          _id: edge.bookmaker,
          name: bookmakers[edge.bookmaker]
        },
        oddsType: edge.oddsType,
        oddsTypeCondition: edge.oddsTypeCondition || 0,
        odds: edge.odds,
        offer: edge.offer,
        edge: edge.edge,
        status: 1,
        output: edge.output
      }))
    }
  }

  componentWillReceiveProps(nextProps) {
    const { edge } = nextProps
    if (!edge)
      return
    for (let bet of nextProps.userbets) {
      if (bet.offer === edge.offer && bet.output === edge.output && bet.odds === edge.odds) {
        return this.setState({userbet: bet, wager: bet.wager, currency: bet.currency})
      }
    }
    this.setState({wager: Math.round(edge.kelly * nextProps.totalBankroll * nextProps.user.kellyFrac), currency: this.props.user.currency, userbet: null})
  }

  componentDidUpdate() {
    const { edge } = this.props
    if (edge && !this.props.hidden) {
      const oddsText = displayOddsType(edge.oddsType, edge.output, edge.oddsTypeCondition).replace(/home|away/gi, matched => {
        return mapOddsTypeObjects[matched]
      })
      document.title = oddsText + ' @ ' + edge.odds
    } else {
      document.title = 'Edgebet'
    }
  }

  render() {
    if (!this.props.edge || this.props.hidden) {
      return (
        <div className='panel selected-edge-container'>
          <div className='panel-body'>
            <p className='lead'>Select an edge and it will appear here.</p>
          </div>
        </div>
      )
    }
    const { edge } = this.props
    return (
      <div className='panel selected-edge-container'>
        <div className='panel-body'>
          <div className='team-box'>
            <span className={'sport ' + SPORTS[edge.sportId].icon} />
            <span className='close' data-tip='Hide this bet' data-for='selected-edge' onClick={this.hideEdge.bind(this)}>×</span>
            <div className='home'>{ edge.homeTeam }</div>
            <div className='vs'>VS</div>
            <div className='away'>{ edge.awayTeam }</div>
          </div>
          <div className='meta'>
            <div>Starts</div>
            <div>{ moment(edge.startTime).fromNow() }</div>
            <div>Bookmaker</div>
            <div>{ bookmakers[edge.bookmaker] }</div>
            { !!edge.country && ([<div key='1'>Country</div>, <div key='2'>{ edge.country }</div>]) }
            { !!edge.competition.name && ([<div key='1'>Competition</div>,<div key='2'>{ edge.competition.name }</div>])}
            <div className='featured'>Odds type</div>
            <div className='featured'>{ displayOddsType(edge.oddsType, edge.output, edge.oddsTypeCondition) }</div>
            <div className='featured'>Odds</div>
            <div className='featured'>{ edge.odds }</div>
          </div>
          <div className='bottom-info'>
            <EdgeBox
              value={currencyToText(Math.round(edge.kelly * this.props.totalBankroll * this.props.user.kellyFrac), this.props.user.currency) }
              text='Bet size' />
            <EdgeBox value={ edge.edge + '%'} text='Edge' />
          </div>
          <form className='form center-block clearfix' onSubmit={ this.addUserbet }>
            <div className='form-group col-xs-3'>
              <select className='form-control' value={ this.state.currency } onChange={ this.onChangeCurrency }>
                { Object.keys(this.props.currencies).map(currency => {
                  return <option key={currency} value={currency}>{ getDisplayCurrency[currency] }</option>
                })}
              </select>
            </div>
            <div className='form-group col-xs-5'>
              <input className='form-control' type='number' min='1' value={this.state.wager} onChange={this.onChangeWager} />
            </div>
            <div className='col-xs-4'>
              <button type='submit' className={'btn ' + (this.state.userbet ? 'btn-warning' : 'btn-success') } onClick={ this.addUserbet }>
                { this.state.userbet ? 'Edit bet' : 'Place bet' }
              </button>
            </div>
            <div className='col-xs-12'>
              { this.props.hidden && (
                <p className='lead pull-left'>This edge is hidden</p>
              )}
            </div>
          </form>
        </div>
        <ReactTooltip place='left' effect='solid' id='selected-edge' />
      </div>
    )
  }
}

class EdgeBox extends Component {
  render() {
    return (
      <div className='box'>
        <div className='value'>{ this.props.value }</div>
        <div className='text'>{ this.props.text }</div>
      </div>
    );
  }
}

export default connect(state => {
  return {
    currencies: state.currencies
  }
})(SelectedEdge)



/** WEBPACK FOOTER **
 ** ./src/components/edgebets/SelectedEdge.js
 **/